import React, { useState, useEffect } from 'react'
import { paymentService } from '../../services/paymentService'
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Alert
} from '@mui/material'

const formatCurrency = (amount) => {
  if (!amount) return '₱0.00'
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP'
  }).format(amount)
}

const formatDateTime = (isoString) => {
  if (!isoString) return ''
  const date = new Date(isoString)
  return date.toLocaleString('en-PH', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const OnlinePaymentsPage = () => {
  const [payments, setPayments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const loadPayments = async () => {
      setLoading(true)
      setError('')
      try {
        const result = await paymentService.getOnlinePayments(100)
        if (result.success) {
          setPayments(result.data || [])
        } else {
          setError(result.error || 'Failed to load online payments')
        }
      } catch (err) {
        setError(err.message || 'Failed to load online payments')
      } finally {
        setLoading(false)
      }
    }

    loadPayments()
  }, [])

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100dvh', py: 2, width: '100%' }}>
      <Container maxWidth={false} disableGutters>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" fontWeight="bold">
            Online Payments
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Payments collected through PayMongo checkout.
          </Typography>
        </Box>

        <Paper sx={{ p: 2.5 }}>
          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          )}

          {!loading && error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {!loading && !error && payments.length === 0 && (
            <Alert severity="info">No online payments found.</Alert>
          )}

          {!loading && !error && payments.length > 0 && (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Reference</TableCell>
                    <TableCell>Customer ID</TableCell>
                    <TableCell>Bill IDs</TableCell>
                    <TableCell>Method</TableCell>
                    <TableCell align="right">Amount</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payments.map((p) => (
                    <TableRow key={p.id || `${p.checkout_session_id}-${p.reference_number}`}>
                      <TableCell>{formatDateTime(p.created_at)}</TableCell>
                      <TableCell>{p.reference_number || p.checkout_session_id}</TableCell>
                      <TableCell>{p.customerid}</TableCell>
                      <TableCell>{p.bill_ids}</TableCell>
                      <TableCell>{p.payment_method || 'N/A'}</TableCell>
                      <TableCell align="right">{formatCurrency(p.total_amount)}</TableCell>
                      <TableCell>
                        <Chip
                          label={p.status || 'Paid'}
                          size="small"
                          color={p.status === 'Paid' ? 'success' : 'default'}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Paper>
      </Container>
    </Box>
  )
}

export default OnlinePaymentsPage

